import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { PerformanceOptimizer } from '@/lib/performanceOptimization';
import { installRuntimeRecovery } from '@/lib/runtimeRecovery';

// Initialize performance optimizations
installRuntimeRecovery();
PerformanceOptimizer.initialize();

createRoot(document.getElementById("root")!).render(<App />);
